import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { TrackerPruneInput } from '@pms/shared';
import { getErrorMessage } from '@/lib/errors';
import { trackingService } from '@/services/tracking.service';
import { TRACKER_KEY } from './trackerQuery';

/** A dry run changes nothing, so only a real prune refreshes the page. */
export function usePruneTrackerImages() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: TrackerPruneInput) => trackingService.prune(input),
    onSuccess: (result) => {
      if (!result.dryRun) queryClient.invalidateQueries({ queryKey: TRACKER_KEY });
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });
}
